import { setCacheValues } from '@axo/form/feature/form-input';
import { isEqual } from 'lodash';
import { useEffect, useState } from 'react';

interface Props<Data extends Record<string, unknown>> {
  defaultValues?: Data;
  configureSteps?: (data: Data) => void;
}

export const useAxoFormData = <Data extends Record<string, unknown>>({
  defaultValues,
  configureSteps,
}: Props<Data>) => {
  const [axoFormData, setAxoFormData] = useState<Data>({} as Data);

  const updateAxoFormData = (data: Partial<Data>) => {
    const updatedData = { ...axoFormData, ...data };
    if (!isEqual(updatedData, axoFormData)) {
      setAxoFormData(updatedData);
      return updatedData;
    }
    return axoFormData;
  };

  useEffect(() => {
    if (defaultValues) {
      setAxoFormData(defaultValues);
      setCacheValues(defaultValues);
      configureSteps?.(defaultValues);
    }
  }, [defaultValues]);

  return { axoFormData, setAxoFormData, updateAxoFormData };
};
